export class IBasicUserSettingsModel {
    UserCode: number = 0;
    FirstName:string = '';
    LastName: string = '';
    Groups: Array<number> = [];
    PermissionGroupId: number = 0;
    NotificationGroups: number[] = [];
    HomeLocationId: number | null = null;
    Supervisor?: number;
    PrimaryEmail: string = '';
    PhoneNumber: string = '';
    SecondaryEmail: string = '';
    flexibleFloatEmployee?: boolean;
    UserId: number = 0;
    UserName: string = '';
    CalenderEnabled?: boolean;
    OptInDailyBranchSummaryEmail?: boolean;
    RestrictAvailabilityOperatingHours: boolean = false;
    OptInDailyUserSummaryEmail?: boolean;
    PreferredLanguage?: number;
    PreferredTimeZone?: number;
    IsActive: boolean = false;
    LoginEnabled: boolean = false;
    IsSpanishSpeaker: boolean = false;
    AccountLocked: boolean = false;
    twoFactorConfigured: boolean = false;
    twoFactorEnabled: boolean = false;
    virtualConferencingUserId: string | null = null;
}
